<tiime-input-container tiimeFormInputContainer contentId="contract-brand-select" [label]="label()" [small]="small">
  <tiime-select
    id="contract-brand-select"
    [placeholder]="label()"
    [formControl]="control"
    [customValue]="control.value ?? ' '"
    data-cy="contract-brand-select"
  >
    <div tiimeSelectOptions>
      @if (businessUnitBrand(); as businessUnitBrand) {
        <div class="divider">Marque du groupe</div>
        <mat-option [value]="businessUnitBrand.name" (onSelectionChange)="emitBrandChange($event, businessUnitBrand)">
          {{ businessUnitBrand.name }}
        </mat-option>
      }
      <div class="divider">Marques commerciales</div>
      @for (brand of selectorData | sortByKey: 'name'; track $index) {
        @if (brand.name !== businessUnitBrand()?.name) {
          <mat-option [value]="brand.name" (onSelectionChange)="emitBrandChange($event, brand)">
            {{ brand.name }}
          </mat-option>
        }
      }
    </div>
    @if (control.value) {
      <div class="image-container" tiimeSelectSuffix>
        @if (logoLoading()) {
          <mat-progress-spinner [diameter]="16" color="primary" mode="indeterminate"></mat-progress-spinner>
        } @else {
          @if (logoUrl()) {
            <app-image-preview [imageUrl]="logoUrl()"></app-image-preview>
          }
        }
      </div>
    }
  </tiime-select>
</tiime-input-container>
